/* BasicButton */
import classNames from "classnames"

import { BasicButtonProps } from "@/types/components/button"
import "./basicButton.scss"
import { CircularProgress } from "@mui/material"
import Icon from "@/components/icon/Icon"

export default function BasicButton({
  type,
  size,
  isLoading,
  icon,
  // html button props
  className,
  children,
  disabled,
  onClick,
  ref,
  ...props
}: BasicButtonProps) {
  const mergedClassName = classNames("BasicButtonCont", className, [type, size, isLoading], {
    disabled,
  })

  return (
    <button
      className={mergedClassName}
      ref={ref}
      disabled={disabled}
      {...props}
      onClick={(e) => {
        if (!disabled && !isLoading && onClick) {
          onClick(e)
        }
      }}>
      {isLoading ? (
        <CircularProgress className="progress-indicator" />
      ) : (
        <>
          {icon ? <Icon type={icon} /> : null}
          {children}
        </>
      )}
    </button>
  )
}
